import React, {useRef} from "react";
import noop from "lodash/noop";

export const MessageContext = React.createContext({text: "", inputRef: {current: {focus: noop}}});

const ChatInputProvider = ({children}) => {
    const [text, setText] = React.useState("");
    const [isFocused, setIsFocused] = React.useState(false);
    const inputRef = useRef(null);
    return (
        <MessageContext.Provider value={{text, setText, isFocused, setIsFocused, inputRef}}>
            {children}
        </MessageContext.Provider>
    );
};

export const useChatInput = () => {
    return React.useContext(MessageContext);
};

export default ChatInputProvider;
